import React from "react";
import Breadcrumb from "../Pages/Breadcrumb";
import Image from "../ui/Image";
import { Link } from "react-router-dom";
import useHomeSection from "../../hooks/useHomeSection";
import { useTranslation } from "react-i18next";
import { FaCalendarAlt, FaUserTie, FaClock } from "react-icons/fa";
import image5 from "../../assets/icons/group-1.png";
import img7 from "../../assets/icons/group-2.png";
import img8 from "../../assets/icons/group-4.png";
import img9 from "../../assets/icons/group-3.png";
const AllAchievements = () => {
    const { t } = useTranslation();
    const { data: achievements, error, isLoading } = useHomeSection({ sectionName: 'ivory_Achievements&per_page=200' });
    document.title = `${t('routes.achievements')} | ${t('ivory')}`;

    if (error) {
        return (
            <div className="flex justify-center items-center relative z-50 bg-white">
                <p id="err">{error?.message || t('custom.err')}</p>
            </div>
        );
    }

    if (isLoading) {
        return (
            <>
                <div className="h-10 w-full l-load-dt my-2"></div>
                <main className="px-20 py-8 max-lg:px-4 grid grid-cols-3 gap-4 max-xl:grid-cols-2 max-lg:grid-cols-1 w-full">
                    {[...Array(6)].map((_, i) => (
                        <div key={i} className="w-full h-72 rounded-lg l-load-dt"></div>
                    ))}
                </main>
            </>
        );
    }

    return (
        <div className="">
            <Breadcrumb pages={[t("routes.achievements")]}/>
         <div className="container">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {achievements?.map((item, index) => (
                    <div key={index} className="bg-[#E6E6E6] shadow-md rounded-lg overflow-hidden border p-4">
                        <div className="relative h-64 w-full">
                            <Image
                                src={item.image || "/default-image.jpg"}
                                alt={item.title}
                                className="object-cover w-full h-full mb-2"
                                style={{ borderRadius: '16px',border: '2px solid #D4AD89' }}
                            />
                        </div>
                        <div className="p-1">
                            <h3 className="text-lg font-semibold text-[#5b2e47] mb-2 text-end mt-2">
                                {item.title}
                            </h3>
                            <Link to={`/achievements/${item.id}`} className="text-sm text-[#b18c5e] flex items-center gap-1">
                                ← {t('moreDetails')}
                            </Link>
                            <div className="flex justify-between items-center mt-4 text-sm text-gray-600">
                                <div className="flex items-center gap-2">
                                   
                                     <span className="icon"><img src={img7} alt="icon" /></span>
                                    <span className="text text-[#b18c5e]">{item.year || "2021"} <br></br><span className="text text-[#6A2F38]">{t('year')}</span></span>
                                </div>
                                <div className="flex items-center gap-2">
                                <span className="icon"><img src={img8} alt="icon" /></span>
                                    <span className="text text-[#b18c5e]">{item.number_trainer || "775"}<br></br><span className="text text-[#6A2F38]"> {t('trainees')}</span></span>
                                </div>
                                <div className="flex items-center gap-2">
                                <span className="icon"><img src={img7} alt="icon" /></span>
                                    <span className="text text-[#b18c5e]">{item.days || "94"} <br></br><span className="text text-[#6A2F38]">{t('trainingDays')}</span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            </div>
        </div>
    );
};

export default AllAchievements;
